import React from 'react'
import { isWeb } from '../../utils/helpers/commonUtils'

export default ({ children, helper, position = 'top', style = {} }) => {
  if (!isWeb) return children

  return (
    <div
      data-tooltip={helper}
      data-flow={position}
      style={style}
      id={'tooltip-view'}
    >
      {children}
    </div>
  )
}
